export default __webpack_public_path__ + "static/media/QuinnTerhore.762e4dc9.jpg";